import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { State } from '../models/State';

@Injectable()
class StatesService {
  private states: State[] = [];
  private defaultState: State = new State({"id":2,"state":"Washington","abbr":"WA","active":1,"created_at":"2018-10-07 00:30:19","updated_at":"2018-10-07 00:30:19"});

  constructor(private http: HttpClient) {
    this.getStates();
  }

  getStates(): Promise<State[]> {
    if (this.states.length) {
      return Promise.resolve(this.states);
    }

    return this.http.get('state')
      .toPromise()
      .then((data: any) => {
        this.states = data.map(d => new State(d));
        this.defaultState = this.states.find(s => s.state === 'Washington');
        return this.states;
      })
      .catch(err => {
        console.error(err);
        return err;
      });
  }

  getStateFromIdOrDefault(id: number): State {
    if (this.states.length) {
      const state = this.states.find(s => s.id === id);
      return state || this.defaultState;
    }
    return this.defaultState;
  }
}

export { StatesService };